export const formatDatesInChartTiks = (tickItem) => { 
    const day = (tickItem.getDate()).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
    const month = (tickItem.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
    return (tickItem instanceof Date) ? `${month}-${day}` : '' 
};